import { Alert, Snackbar } from "@mui/material";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideSnackbar } from "../store/slices/snackbar.slice";

const SnackBar = () => {
  const snackDetails = useSelector((state) => state.snackbar);
  const dispatch = useDispatch();
  const { show, variant, message, duration } = snackDetails;
  const closeSnackBar = () => {
    dispatch(hideSnackbar());
  };
  return (
    <Snackbar
      open={show}
      autoHideDuration={duration || 4000}
      onClose={closeSnackBar}
    >
      <Alert
        onClose={closeSnackBar}
        severity={variant || "info"}
        sx={{ width: "100%" }}
        variant="filled"
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackBar;
